import { User } from "@/modules/reporting/domain/User";
export class SaveUserInvoiceNotificationCommand {
  constructor(
    public readonly userId: number,
    public readonly enable_invoice_notifications: boolean
  ) {}
}
export class SaveUserInvoiceNotificationCommandHandler {
  private repo: UserRepoInterface;

  constructor(repo: UserRepoInterface) {
    this.repo = repo;
  }

  async handle(command: SaveUserInvoiceNotificationCommand): Promise<void> {
    const user = new User(command.userId);
    user.toggleAndSaveInvoiceNotification(command.enable_invoice_notifications);
    await this.repo.save(user);
  }
}
export interface UserRepoInterface {
  save(user: User): Promise<void>;
}